// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const VulnerableFunctionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="VulnerableFunctionIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M14.757 14.243 19 10l-4.243-4.243-1.06 1.061L16.879 10l-3.182 3.182z" />
      <path d="M5.243 5.757 1 10l4.243 4.243 1.06-1.061L3.121 10l3.182-3.182z" />
      <path d="M10.996 12h-2V4h2z" />
      <path d="M8.746 14.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const VulnerableFunctionIcon = /* @__PURE__ */ Object.assign(
  VulnerableFunctionIconComponent,
  { displayName: 'VulnerableFunctionIcon' },
);
